import React, { useState } from 'react';

import useFilterForCheckbox from '../hooks/useFilterForCheckbox';
import childrensCategories from '../../utils/childrens-categories';

import FilterItem from './FilterItem';

/**
 * ChildrensCategoriesFilter
 *
 * A filter that returns selected languages
 *
 * @param {Object} props
 * @param {Object} props.context
 * @param {Object} props.setStart
 * @param {string} props.dataCode
 * @param {Object} props.scrollToTop
 */
const ChildrensCategoriesFilter = ({ context, setStart, dataCode, scrollToTop }) => {
  const [ isActive, setIsActive ] = useState( false );
  const contextChildrensCategories = JSON.parse( context.selectedChildrensCategories );

  const {
    checked,
    setChecked,
    handleFilter
  } = useFilterForCheckbox( setStart, dataCode, scrollToTop );

  // Map the children's categories to use the frontend labels
  const childrensCategoriesOptions = childrensCategories
    .map( category => ({
      label: category['fe-label'],
      value: category.value
    }) )
    .sort( ( a, b ) => a.label.localeCompare( b.label ) );

  const selectedChildrensCategories = childrensCategoriesOptions.filter( ( cat ) => contextChildrensCategories.includes( cat.value ) );

  return (
    selectedChildrensCategories.length > 0 && (
      <FilterItem
        data={ selectedChildrensCategories }
        setStart={ setStart }
        dataCode={ dataCode }
        title="Children's Category"
        isActive={ isActive }
        setIsActive={ setIsActive }
        checked={ checked }
        setChecked={ setChecked }
        handleFilter={ ( e, index ) => handleFilter( e, index ) }
        scrollToTop={ scrollToTop }
      />
    )
  );
};

export default ChildrensCategoriesFilter;
